import type { ReactNode } from "react";

import { type Location } from "@/api/locations";

import { locationEntity } from "./entities";
import { EntityCombobox } from "./EntityCombobox";

interface Props {
  value: number | null;
  onChange: (id: number | null) => void;
  size?: "sm" | "default";
  variant?: "outline" | "ghost";
  className?: string;
  allowClear?: boolean;
  /** Override trigger styling (e.g. the item-detail "explore" tab slot). */
  triggerClassName?: string;
  /** Custom trigger content; receives the selected location (or null). */
  renderTriggerContent?: (selected: Location | null) => ReactNode;
  /** Aria label override for the trigger. */
  ariaLabel?: string;
}

export function LocationCombobox({ allowClear = false, ...rest }: Props) {
  return (
    <EntityCombobox<Location>
      descriptor={locationEntity}
      allowClear={allowClear}
      {...rest}
    />
  );
}
